// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"119e5592","455":"4004e808","977":"d01c95bf"}[chunkId] + ".chunk.js";
};